import * as actionType from "./withdrawalActionType";

const initialState = {
  isLoading: false,
  withdrawals: []
};

export const withdrawalReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_ADMIN_WITHDRAWALS:
        case actionType.APPROVE_WITHDRAWAL:
        case actionType.REJECT_WITHDRAWAL:
            return {
                ...state,
                isLoading: true
            };
        case actionType.GET_ADMIN_WITHDRAWALS_FAILURE:
        case actionType.APPROVE_WITHDRAWAL_FAILURE:
        case actionType.REJECT_WITHDRAWAL_FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case actionType.GET_ADMIN_WITHDRAWALS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                withdrawals: action.payload ? action.payload : []
            };
        case actionType.APPROVE_WITHDRAWAL_SUCCESS:
        case actionType.REJECT_WITHDRAWAL_SUCCESS:
            return {
                ...state,
                isLoading: false
            };
        default:
            return state;
    }
}
